<template>
  <f-textfield
    class="from17-open"
    :input="component.link"
    :placeholder="$vt('title...')"
    readonly
  >
    <template #label>{{ $vt(component.title) }}</template>
    <template #helper>{{ $vt(component.description) }}</template>
    <template #action>
      <f-button type="tertiary" :href="component.link" blank>{{
        "Open" | vtranslate
      }}</f-button>
    </template>
  </f-textfield>
</template>
<script>
export default {
  props: ["component", "handler"],
};
</script>

<style lang="scss">
</style>